<script lang="ts" setup>
  import { computed } from "vue";
  import { $t } from "@/locales";

  defineOptions({ name: "MenuToggler" });

  interface Props {
    direction: "ltr" | "rtl";
    /** Show collapsed icon */
    collapsed?: boolean;
    /** Arrow style icon */
    arrowIcon?: boolean;
  }

  const props = defineProps<Props>();

  type NumberBool = 0 | 1;

  const icon = computed(() => {
    const isRtl = props.direction === "rtl";

    // Define icons based on direction
    const icons: Record<NumberBool, Record<NumberBool, string>> = {
      0: {
        // For menu-fold icons
        0: isRtl ? "line-md:menu-fold-right" : "line-md:menu-fold-left",
        1: isRtl ? "line-md:menu-fold-left" : "line-md:menu-fold-right",
      },
      1: {
        // For arrow icons
        0: isRtl ? "ph-caret-double-right-bold" : "ph-caret-double-left-bold",
        1: isRtl ? "ph-caret-double-left-bold" : "ph-caret-double-right-bold",
      },
    };

    const arrowIcon = Number(props.arrowIcon || false) as NumberBool;
    const collapsed = Number(props.collapsed || false) as NumberBool;

    return icons[arrowIcon][collapsed];
  });
</script>

<template>
  <ButtonIcon
    :tooltip-content="collapsed ? $t('icon.expand') : $t('icon.collapse')"
    :tooltip-placement="
      props.direction === 'rtl' ? 'bottom-end' : 'bottom-start'
    "
    overlap
  >
    <SvgIcon :icon="icon" />
  </ButtonIcon>
</template>

<style scoped></style>
